exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expenses .table-row[data-v-5b776046] {\r\n    font-size: 12px!important;\n}\n.expenses__back[data-v-5b776046]{\r\n    margin: 10px;\n}\n.expenses__back__icon[data-v-5b776046]{\r\n      width: 1.5rem;\r\n      height: 1.5rem;\n}\n.expenses__text[data-v-5b776046]{\r\n    margin: 10px;\n}\r\n", ""]);

// exports
